import { lazy } from 'react'

import CursorClickIcon from '@heroicons/react/outline/esm/CursorClickIcon.js'

import { I18nShape } from '@tribeplatform/react-components/i18n'

import { BlockType, RegisteredBlock } from '../../types/index.js'
import { HeroBannerBlock as Component } from './Block.js'
import { HeroBannerProps } from './types.js'

const Settings = lazy(() =>
  import('./Settings.js').then(m => ({ default: m.HeroBannerBlockSettings })),
)

export const RegisteredHeroBannerBlock = (
  intl: I18nShape,
): RegisteredBlock<HeroBannerProps> => {
  const { $t } = intl

  return {
    recommendedName: 'HeroBanner',
    Component,
    config: {
      type: BlockType.Block,
      usable: true,

      displayName: $t({
        id: 'Blocks.HeroBanner.DisplayName',
        defaultMessage: 'Hero Banner',
      }),
      Settings,
      Icon: <CursorClickIcon />,
      defaultProps: {
        title: $t({
          id: 'Blocks.HeroBanner.DefaultTitle',
          defaultMessage: 'Welcome to {COMMUNITY}',
        }),
        description: '',
        align: 'center',
        textColor: 'dark',
        imageTintOpacity: 0,
        imagePosition: 'cover',
        extraPadding: 3,
        style: 'card',
        backgroundType: 'image',
      },
    },
  }
}
